import { z } from 'zod';

const DataEntrySchema = z.object({
  text: z.string(),
  seatmap: z.boolean(),
  pano: z.boolean(),
});

const AllNodesDisclaimerSchema = z.object({
  enabled: z.boolean(),
  all3dViews: z.boolean(),
  allSeatmaps: z.boolean(),
  text: z.string(),
});

export const DisclaimerDataSchema = z.record(DataEntrySchema)

export const DisclaimerSchema = z.object({
  enabled: z.boolean(),
  data: DisclaimerDataSchema,
  allNodes: AllNodesDisclaimerSchema,
});

export const DisclaimerUiSchema = {
  text: '',
  seatmap: false,
  pano: false
};